//CHECKED
import React, { FC, useState } from "react";
import styled from "styled-components";
import lang from "../functions/lang";
import TargetIcon from "./Icons/Target";

interface ILocateMeButton {
  onClick: () => void;
}
const Locate = styled.div`
  margin: 0;
  padding: 0.6rem 1.4rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;
const Icon = styled.img`
  width: 18px;
  height: 18px;
  position: relative;
  cursor: pointer;
  margin-top: -2px;
`;

const LocateMeMessage = styled.p`
  font-weight: 400;
  font-size: 14px;
  color: #522398;
  cursor: pointer;
  padding-left: 7px;
`;
export const LocateMeButton: FC<ILocateMeButton> = ({ onClick }) => {
  const [size, setSize] = useState(
    window.innerWidth <= 770 ? "mobile" : "desktop"
  );

  return (
    <Locate>
      <TargetIcon onClick={onClick} width={18} height={18} />

      {size == "desktop" ? (
        <LocateMeMessage onClick={onClick}>
          {lang("modal.use_current_location", window.data?.language || "en")}
        </LocateMeMessage>
      ) : null}
    </Locate>
  );
};
